import request from '@/utils/request'

/**
 * 获取服务注册列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listServiceRegisters(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/serviceRegister.listServiceRegisters',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取应用列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listApps(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app.listApps',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新服务注册信息
 * @param {Object} data 更新数据
 * @returns {Promise} Promise对象
 */
export function updateServiceRegister(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/serviceRegister.updateServiceRegister',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除服务注册
 * @param {Object} data 删除数据
 * @returns {Promise} Promise对象
 */
export function deleteServiceRegister(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/serviceRegister.deleteServiceRegister',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}